import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { TableRow, TableRowColumn } from 'material-ui/Table';
import Grid from '../grid/Grid';
import enhancer from '../enhancer';

class GradeGroups extends React.Component {
  renderRow = ({ node }) => (
    <TableRow key={node.id}>
      <TableRowColumn>{node.name}</TableRowColumn>
      <TableRowColumn>{node.description}</TableRowColumn>
    </TableRow>
  );

  render() {
    const { master } = this.props;

    return (
      <div>
        <Grid
          headers={['Name', 'Description']}
          rows={master.allGradeGroups.edges}
          renderRow={this.renderRow}
        />
      </div>
    );
  }
}

const query = graphql`
  query GradeGroupsAdminQuery {
    master {
      ...GradeGroups_master
    }
  }
`;

export default enhancer(GradeGroups, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(GradeGroups, {
        master: graphql`
          fragment GradeGroups_master on Master {
            allGradeGroups(first: 10) {
              edges {
                node {
                  id
                  name
                  description
                }
              }
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/components/master/GradeGroups.js